import { Button, ButtonGroup } from "@chakra-ui/react";
function ActionButtonGroup({ data, onAction, isDisabled }) {
  return (
    <ButtonGroup spacing={4}>
      <Button
        colorPalette="green"
        size={"sm"}
        onClick={() => onAction("accept", data)}
        disabled={isDisabled}
      >
        Accept
      </Button>
      <Button
        colorPalette="red"
        size={"sm"}
        onClick={() => onAction("reject", data)}
        disabled={isDisabled}
      >
        Reject
      </Button>
    </ButtonGroup>
  );
}

export default ActionButtonGroup;
